export default __webpack_public_path__ + "static/media/ind_serv.4af3483b.png";